import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { FirebaseConfig } from '@/types';

// Firebase configuration
const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBdaZ-cKyAs6Q_59dNDFb2SB-0EoYiBXqs",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "realestatesmartai.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "realestatesmartai",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "realestatesmartai.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "846016871674",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:846016871674:web:f112c425ba6da623751d43"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators in development if running on localhost
if (import.meta.env.DEV && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  try {
    //console we in dev mode
    console.log('We are in dev mode and using Firebase Emulators');
    connectAuthEmulator(auth, 'http://127.0.0.1:9099');
    connectFirestoreEmulator(db, '127.0.0.1', 8090);
    connectStorageEmulator(storage, '127.0.0.1', 9199);
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  } catch (error) {
    console.warn('Firebase emulators already connected or not available');
  }
}

export default app;
